<template>
  <div class="big-box">
    <div class="main">
      <navigation :crumbs="crumbs" @jumpColumn="jumpColumn" />
      <div class="info-page">
        <div style="clear:both" />
        <div class="title">{{ content.title }}</div>
        <div class="subtitle">
          <span v-if="content.source" class="time">
            来源：
            <font>{{ content.source }}</font>
          </span>

          <span v-if="content.publishedtime" class="time">
            发布时间：
            <font>{{ content.publishedtime | parseTime('{y}-{m}-{d}') }}</font>
          </span>
          <!-- <span v-if="content.readCount" class="time">
            浏览次数：
            <font color="#4C91E3">{{ content.readCount }}</font>
          </span> -->
        </div>
        <video v-if="content.videoPath" controls class="video-style" :src="content.videoPath" />
        <div class="content new-content" v-html="richContent" />
        <div class="other-info">
          <div v-if="content.reporter">记者： {{ content.reporter }}</div>
          <div v-if="content.editor">编辑： {{ content.editor }}</div>
          <div v-if="content.publishedid">编校： {{ content.publishedid }}</div>
          <div v-if="content.auditUsername">审发： {{ content.auditUsername }}</div>
        </div>
        <div v-if="content.attachmentPath && content.attachmentPath != '[]' " class="file-list">
          <div class="title">附件：</div>
          <div v-for="file in content.attachmentPath" :key="file.uid" class="file-item">
            <div class="name">{{ file.name }}</div>
            <span :href="cfg.imageDomain + file.url" :download="file.name" class="down-file" @click="fileDownLoad(file.url,file.name)">下载</span>
            <span :href="cfg.imageDomain + file.url" target="_blank" class="down-file" @click="filePreview(file.url,file.name)">查看内容</span>
          </div>
        </div>
        <div class="foot">
          <div v-if="content.prevArticleTitle">
            上一条：
            <a @click="jump(content.prevArticleId)">{{ content.prevArticleTitle }}</a>
          </div>
          <div v-if="content.nextArticleTitle">
            下一条：
            <a @click="jump(content.nextArticleId)">{{ content.nextArticleTitle }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import { getContent } from '@/api/common';
import navigation from '@/components/navigation';
import { getNavigation } from '@/api/common';

// 富文本图片按需取图的宽度档位，对应 CDN 的 imageView2/2/w/{N}
// 收敛成固定档位而不是按实际像素取值，可以更好地命中 CDN 缓存
const CDN_WIDTH_STEPS = [750, 1080, 1440, 2048];
// 移动端断点，与样式里的 @media 保持一致
const MOBILE_BREAKPOINT = 768;

export default {
  name: 'Index',
  components: {
    navigation
  },
  data() {
    return {
      newsTitle: '辟谣要闻',
      noticeTitle: '公告栏',
      newList: { },
      noticeList: { },
      content: '',
      id: '',
      crumbs: []
    };
  },
  computed: {
    ...mapState(['platFromArray', 'columnTree']),
    // 渲染前统一规范化后台返回的富文本，避免编辑器写死的宽高在移动端撑破布局
    richContent() {
      return this.normalizeRichText(this.content && this.content.content);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(route) {
        const { query } = route;
        console.log(query)
        this.getContent(query);
      }
    }
  },
  methods: {
    /**
     * 富文本规范化：只做「打标记 + 移动端按需取图 + 安全清理」，不改动正文结构、不改动任何尺寸属性
     * 尺寸自适应完全交给 CSS 处理，避免误伤 PC 端作者指定的图片尺寸
     * 解析失败时原样返回，保证任何异常情况下内容都不会丢失
     */
    normalizeRichText(html) {
      if (!html || typeof html !== 'string') return '';
      if (typeof window === 'undefined' || typeof DOMParser === 'undefined') return html;

      let body = null;
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        body = doc && doc.body;
      } catch (e) {
        return html;
      }
      if (!body) return html;

      try {
        const targetWidth = this.getTargetImgWidth();
        const imgList = body.querySelectorAll('img');

        for (let i = 0; i < imgList.length; i++) {
          const img = imgList[i];

          // 1. 按屏幕宽度向 CDN 要合适尺寸的图，只缩不放；PC 端不改写，保持原画质
          //    注意：这里刻意不剥离 img 的 width/height 属性和行内样式，
          //    因为带 !important 的 CSS 优先级本身就高于行内样式，
          //    保留 width 才能让 PC 端「作者指定小尺寸」的图片维持原样（min(指定宽, 100%)）
          const src = img.getAttribute('src');
          const nextSrc = this.resizeCdnImage(src, targetWidth);
          if (nextSrc && nextSrc !== src) img.setAttribute('src', nextSrc);

          img.setAttribute('loading', 'lazy');
          img.setAttribute('decoding', 'async');

          // 2. 给图片所在段落打标记，样式里去掉首行缩进，避免图片被 text-indent 顶偏
          let parent = img.parentNode;
          while (parent && parent !== body && parent.nodeType === 1) {
            const tag = parent.tagName;
            if (tag === 'P' || tag === 'DIV' || tag === 'SECTION') {
              const cls = parent.getAttribute('class') || '';
              if (cls.indexOf('rich-media-p') === -1) {
                parent.setAttribute('class', (cls ? cls + ' ' : '') + 'rich-media-p');
              }
              break;
            }
            parent = parent.parentNode;
          }
        }

        // 3. 顺手清掉内联事件属性，降低富文本 XSS 面（innerHTML 不执行 script，但 onerror 会触发）
        const allNodes = body.querySelectorAll('*');
        for (let i = 0; i < allNodes.length; i++) {
          const el = allNodes[i];
          const attrs = el.attributes;
          for (let j = attrs.length - 1; j >= 0; j--) {
            const name = attrs[j].name;
            if (/^on/i.test(name)) el.removeAttribute(name);
          }
        }

        return body.innerHTML;
      } catch (e) {
        console.warn('[news] 富文本规范化失败，回退原始内容', e);
        return html;
      }
    },
    getTargetImgWidth() {
      const cssWidth = (document.documentElement && document.documentElement.clientWidth) || window.innerWidth || 0;
      // 只在移动端做按需取图，PC 端返回 0 表示不改写 src，画质与改动前完全一致
      if (!cssWidth || cssWidth > MOBILE_BREAKPOINT) return 0;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const need = cssWidth * dpr;
      for (let i = 0; i < CDN_WIDTH_STEPS.length; i++) {
        if (CDN_WIDTH_STEPS[i] >= need) return CDN_WIDTH_STEPS[i];
      }
      return CDN_WIDTH_STEPS[CDN_WIDTH_STEPS.length - 1];
    },
    resizeCdnImage(src, targetWidth) {
      if (!src || !targetWidth) return src;
      const re = /(imageView2\/\d+\/w\/)(\d+)/;
      const matched = src.match(re);
      // 非 CDN 处理链接不动；目标宽度不小于原参数时也不动，避免把小图放大失真
      if (!matched || Number(matched[2]) <= targetWidth) return src;
      return src.replace(re, '$1' + targetWidth);
    },
    getContent(data) {
      // data = this.buildParams(data);
      getContent(data).then(res => {
        const content = res.data;
        this.content = content;

        this.columnList(content.customLabel)

        window.scrollTo({ top: 0 })
      });
    },
    jump(id) {
      this.getContent({ id }).then(res => {
        this.content = res.data;
        console.log(this.content);
      });
    },
    columnList(name) {
      getNavigation(name).then(res => {
        console.log('%c 🥧 res.data: ', 'font-size:20px;background-color: #E41A6A;color:#fff;', res.result);
        const columnListArr = JSON.parse(res.data.value)
        this.getCrumbs(name, columnListArr);
      })
    },
    getCrumbs(columnName, columnObj, crtColumn) {
      const topColumnName = columnObj.filter(v => v.text === columnName);
      // 顶级
      if (topColumnName.length) {
        this.crumbs = [columnName];
        return;
      }
    },
    getCurrentColumn(columnName, columnList) {
      let crtColumn = {};
      for (let index = 0; index < columnList.length; index++) {
        const column = columnList[index];
        if (column.columnList && (columnName !== column.name)) {
          crtColumn = this.getCurrentColumn(columnName, column.columnList)
        } else if (columnName === column.name) {
          crtColumn = column;
        }
      }
      return crtColumn;
    },
    jumpColumn(colubName) {
      // 判断当前栏目是否是 单页 如果是单页
      if (!this.content.columnType) {
        this.$router.push({
          path: '/subPage',
          query: {
            name: colubName
          }
        })
      }
    },
    filePreview(filePath, fileName) {
      // 判断文件格式
      var previewType = ['txt', 'png', 'jpg', 'pdf'];
      var fileType = fileName.split('.');
      fileType = fileType[fileType.length - 1];
      if (!previewType.includes(fileType)) {
        this.$message.warning('该类型文件暂不支持预览');
        return
      }
      var a = document.createElement('a');
      a.style.display = 'none';
      // a.download = fileName;
      // var blob = new Blob(this.cfg.imageDomain + filePath); // 字符内容转变成blob地址
      // a.href = URL.createObjectURL(blob);
      a.href = this.cfg.imageDomain + filePath;
      document.body.appendChild(a);
      a.click(); // 触发点击
      document.body.removeChild(a); // 然后移除
    },
    fileDownLoad(filePath, fileName) {
      var x = new XMLHttpRequest()
      var uri = this.cfg.imageDomain + filePath;
      x.open('GET', uri, true);
      x.responseType = 'blob';
      x.onload = function(e) {
        download(x.response, fileName, x.response.type);
      };
      x.send();
    }
  }
};
</script>

<style lang="less" scoped>
.big-box {
  width: 100%;
  font-family: '宋体';
  .main {
  }
}
.video-style{
  width: 720px;
  height: 480px;
  margin-left: 50%;
  transform: translateX(-50%);
}
.main {
  overflow: hidden;
  /* 等价改写：父级 .app-main 在 >768px 时恒为 1200px，
     所以这里 width:100% + max-width:1200px 的计算结果与原来的 width:1200px 完全一致，
     区别只是父容器一旦改成自适应，本页不需要再跟着改 */
  width: 100%;
  max-width: 1200px;
  padding: 0;
  margin: 14px auto 0;
  position: relative;
}
@media screen and (max-width: 768px) {
  .video-style {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  .main {
    padding: 0 10px;
  }
}
.page-title {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font: 600 14px/40px PingFangHK;
  background: #99bce0;
  padding-left: 10px;
  font-family: 宋体;
}
.flex_row_center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.site_img {
  width: 20px;
  height: 24px;
  margin-right: 10px;
}
.title {
  line-height: 38px;
}
.info-page {
  background: #fff;
  padding: 30px;
  overflow: hidden;
  margin-top: 14px;
  line-height: 30px;
  min-height: 200px;
}
.info-page .title {
  clear: both;
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
  font-size: 36px;
  line-height: 47px;
  color: #0060B5;
}
.info-page .subtitle {
  display: flex;
  justify-content:space-around;
  margin-top: 40px;
  padding-bottom: 60px;
  border-bottom: 1px solid #CCCCCC;
}
.info-page .time {
  font-size: 18px;
  color: #9b9b9b;
  margin-right: 20px;
}
.new-content{
  padding: 40px 0;
  font-size: 18px;
  border-bottom: 1px solid #CCCCCC;
  /* 只在内容原本就会溢出时才生效，正常中文排版无影响 */
  overflow-wrap: break-word;

  /* 兜底：富文本里任何元素都不允许超出正文容器。
     对 block 元素（width:auto）和 inline 元素均无实际影响，
     只有原本就溢出容器的元素才会被收进来 */
  /deep/ * {
    max-width: 100%;
  }

  /* 图片：块级居中 + 等比自适应，取代原来的 margin-left:50% + translateX(-50%)。
     原方案里 transform 不参与布局，图片仍按固有宽度占位，两侧被父级 overflow:hidden 裁掉。
     注意两个刻意保守的处理：
     1) 垂直 margin 保持 0，与改动前的 margin:0 !important 等价，PC 端图文间距不变；
     2) 不声明 width，让行内 width 与 max-width:100% 协同 → 最终宽度 = min(作者指定宽, 容器宽)，
        PC 端「作者指定小尺寸」的图片维持原样，不会被撑成全宽 */
  /deep/ img {
    display: block;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 auto !important;
    transform: none !important;
    float: none !important;
  }

  /* 图片所在段落去掉首行缩进，避免图片被 text-indent 顶偏。
     不加 text-align:center，以免把同段落里的图注文字一起改成居中 */
  /deep/ .rich-media-p {
    text-indent: 0 !important;
  }

  /* 内嵌媒体只设上限、不强制拉伸，避免改变 PC 端已有的固定尺寸 */
  /deep/ video,
  /deep/ iframe,
  /deep/ audio {
    max-width: 100% !important;
    height: auto;
  }
}
.file-list{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .file-item{
    display: flex;
    .down-file{
      margin-left: 20px;
      &:hover{
        color: #367dbe;
      }
    }
  }
}
.other-info{
  margin-top: 40px;
  div{
    font-size: 18px;
    font-weight: 400;
    line-height: 36px;
    color: #666666;
  }
}
.foot {
  margin-top: 20px;
  margin-left: 10px;
  font-size:14px;
  font-family:宋体;
}
.foot div{
  margin-top: 20px;
}
.foot div a:hover{
 color: #337ab7;
 text-decoration: underline;
}
@media screen and (max-width: 768px) {
  .info-page {
    padding: 15px;
  }
  .info-page .title {
    font-size: 24px;
    line-height: 32px;
  }
  .info-page .subtitle {
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    margin-top: 20px;

    .time {
      margin-bottom: 5px;
      font-size: 14px;
    }
  }
  /* 表格改横向滚动只在移动端生效，PC 端表格布局完全保持原样 */
  .new-content {
    /deep/ table {
      display: block;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}
</style>
